<template>
<div class="mt_140">

      <ccMenu ref="cc_menu"></ccMenu>
      <ccLoading v-show="loading" ref="cc_loading"></ccLoading>

      <div class="container">
      <div class="row">
      <div class="col-md-12">

        <!-- row -->
        <div class="row">

            <!-- coluna 2 -->
            <div class="col-md-2">
              <ccMenuConta :num=2></ccMenuConta>
            </div">
            <!-- fim coluna 2 -->

            <!-- coluna 10 -->
            <div class="col-md-10 p-4" style="background: transparent linear-gradient(152deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box; box-shadow: 0px 3px 6px #00000029;">

                <!-- DADOS PESSOAIS -->
                <section class="mb-3">

                  <div class="text_laranja text-center mb-3" v-show="loading">
                    <div class="spinner-grow spinner-grow-sm" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    Carregando
                  </div>

                  <div class="row mb-3">
                    <div class="col-6 text_12 text_bold text_cinza">REDEFINIÇÃO DE SENHA</div>
                  </div>

                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6 offset-md-3">
                          <input type="password" v-model="senha_atual" class="form-control" placeholder="Senha Atual">
                        </div>
                        <div class="col-6 offset-md-3">
                          <input type="password" v-model="senha1" class="form-control" placeholder="Nova Senha">
                        </div>
                        <div class="col-6 offset-md-3">
                          <input type="password" v-model="senha2" class="form-control" placeholder="Confirme sua senha">
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- BOTAO SALVAR DADOS -->
                <section>
                  <div class="row mb-3">
                    <div class="col-md-4 text_12 text_bold text_cinza text-end">
                      <router-link to="/conta/resumo" class="btn btn-outline-danger w-100 btn-sm mt-3">CANCELAR</router-link>
                    </div>
                    <div class="col-md-4 offset-4 text_12 text_bold text_cinza text-end">
                      <button class="btn btn-outline-success w-100 btn-sm mt-3" @click="save()">SALVAR DADOS DA CONTA</button>
                    </div>
                  </div>
                </section>

            </div>
          <!-- fim coluna 10 -->

        </div>
        <!-- fim row -->

    </div>
    </div>
    </div>

    <ccFooter></ccFooter>

</div>
</template>

<script>

import axios from 'axios';
import { TheMask } from 'vue-the-mask';
import ccMenu from '../layout/menu.vue'
import ccMenuConta from '../conta/menu_conta.vue'
import ccLoading from '../cc_geral/cc_loading.vue'
import ccFooter from '../layout/footer.vue'

export default {

  data() {
    return {
      titulo: 'MEUS DADOS',

      //geral
      base_url_api: process.env.BASE_URL_API,
      user: {},
      loading: false,
      errors: [],

      //variaveis
      senha_atual: null,
      senha1: null,
      senha2: null
    }
  },

  components: { ccMenu, TheMask, ccMenuConta, ccLoading, ccFooter },

  created() {
    localStorage.setItem("base_url_api_mobile", this.base_url_api)

    let a = JSON.parse(localStorage.getItem("user"));
    if (a == null) { this.user = {} } else { this.user = a }
  },

  methods: {

    save() {
      this.loading = true;

      var body = {
        nome_completo: this.nome_completo,
        nome_last: this.nome_last,
        cpf: this.cpf,
        email: this.email,
        rg: this.rg,
        nascimento: this.nascimento,
        rua: this.rua,
        bairro: this.bairro,
        estado_id: this.estado_id,
        cep: this.cep,
        telefone: this.telefone,
      };

      var header = { 'headers': { 'x-access-token': this.user.access_token, } };
      axios.post(this.base_url_api + 'user/update', body, header)
        .then(response => {
          alert("Registro salvo com sucesso!")
          this.loading = false
        })
        .catch(e => {
          this.errors.push(e);
          alert(e)
          //this.expluse_para_login()
        });
    },

  }

}
</script>

<style scoped>
  .card{
    background: #FFFFFF08 0% 0% no-repeat padding-box;
    color:#fff;
  }

  input.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control.disabled {
    background-color: #21232d;
    background-image: url("../../assets/image/cadeado.svg");
    background-size: 20px;
    background-position: right;
    background-repeat: no-repeat;
  }

  select.form-control {
    background: transparent linear-gradient(180deg, #FFFFFF0D 0%, #8080800D 100%) 0% 0% no-repeat padding-box;
    color: #909196;
    margin-bottom: 10px;
    border: none;
    padding: 10px;
    font-size: 13px;
  }

  input.form-control::placeholder {
    color: #B7B7B780;
    font-size: 13px;
  }

  option[value=0] {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/conta/reset_senha.vue